<template>
  <div class="home-content" @click="handleClick">
    <Head ref="head"></Head>
    <div v-if="isMaxScreen" class="pc_business-container">
      <div class="business-box">
        <div class="business-left-container">
          <div class="business-content">
            <div class="business-content-title">{{ $t('home.business.646v04syvpk0') }}</div>
            <div class="business-content-sub-title">
              {{ $t('home.business.646v04syxs80') }}
            </div>
            <div class="business-content-container">
              <div v-for="item in businessList" :key="item.name" class="business-content-item">
                <div class="business-content-item-title">{{ item.title }}</div>
                <div v-for="(text, i) in item.texts" :key="i" class="business-content-item-text">
                  {{ text }}
                </div>
              </div>
              <div class="business-content-item-text email-row">
                {{ $t('home.business.646v04syy6g0') }}
                <span class="email-box">Lucy.zhan@danghuan.com</span>
              </div>
            </div>
          </div>
        </div>
        <div class="business-right-container">
          <div class="right-form-title-box">{{ $t('home.business.646v04syya80') }}</div>
          <el-form
            class="business-right-form"
            ref="form"
            :model="form"
            :rules="rules"
            label-width="0px"
          >
            <el-form-item class="normal-form-item" label="" prop="customerName">
              <el-input
                :placeholder="$t('home.business.646v04syydg0')"
                style="width: 550px"
                v-model="form.customerName"
                :maxlength="32"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="select-mobile-number-form-item" label="" prop="mobileNumber">
              <el-input
                ref="input-mobileNumber"
                :placeholder="$t('home.business.646v04syyh40')"
                v-model="form.mobileNumber"
                style="width: 550px"
                :maxlength="16"
                @input="handleInputMoboleNumber('mobileNumber', $event)"
              >
                <!-- <el-select
                  v-model="form.mobileAreaCode"
                  slot="prepend"
                  :popper-append-to-body="false"
                  style="width: 160px"
                >
                  <el-option
                    v-for="(item, key) in mobileAreaCode"
                    :key="key"
                    :value="key"
                    :label="`${item} (${key})`"
                  ></el-option>
                </el-select> -->
                <el-select
                  v-model="form.mobileAreaCode"
                  slot="prepend"
                  :popper-append-to-body="false"
                  style="width: 160px"
                >
                  <img :src="getFlagUrl" alt="" slot="prefix" style="width: 24px; height: 24px" />
                  <el-option
                    v-for="(item, key) in mobileAreaCode"
                    :key="item.areaCode"
                    :value="item.areaCode"
                  >
                    <div style="display: flex; align-items: center">
                      <img
                        :src="item.flagUrl"
                        alt=""
                        style="width: 24px; height: 24px; margin-right: 10px"
                      />
                      {{ item.areaCode }} {{ item.countryName }}
                    </div>
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item class="normal-form-item" label="" prop="email">
              <el-input
                :placeholder="$t('home.business.646v04syyyw0')"
                style="width: 550px"
                v-model="form.email"
                :maxlength="50"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="normal-form-item region-form-item" label="" prop="countryCode">
              <div class="region-item-name">{{ $t('home.business.646v0gsyz1s0') }}</div>
              <el-select
                v-model="form.countryCode"
                :popper-append-to-body="false"
                :placeholder="$t('home.business.646v04syz1s0')"
                style="width: 550px"
              >
                <el-option
                  v-for="(item, key) in nationNameAndNationNo"
                  :key="key"
                  :value="key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="normal-form-item privacy-policy-form-item" label="" prop="">
              <div class="agree-policy-container">
                <div class="agree-policy-box">
                  <img
                    @click="form.checked = !form.checked"
                    :src="form.checked ? checkedIcon : uncheckedIcon"
                    class="check-icon"
                  />
                  {{ $t('home.business.646v04syz4o0') }}
                </div>
                <span @click="handlePolicy" class="policy-text">{{
                  $t('home.business.646v04syzkc0')
                }}</span>
              </div>
            </el-form-item>
            <el-form-item label="" prop="">
              <div class="btn-container">
                <div class="btn-box" @click="handleSubmitForm">
                  {{ $t('home.business.646v04syzok0') }}
                  <img :src="arrowIcon" class="arrow-icon" />
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div v-else class="business-container">
      <div class="business-left-container">
        <div class="business-content">
          <div class="business-content-title">{{ $t('home.business.646v04syvpk0') }}</div>
          <div class="business-content-sub-title">
            {{ $t('home.business.646v04syxs80') }}
          </div>
          <div class="business-content-container">
            <div v-for="item in businessList" :key="item.name" class="business-content-item">
              <div class="business-content-item-title">{{ item.title }}</div>
              <div v-for="(text, i) in item.texts" :key="i" class="business-content-item-text">
                {{ text }}
              </div>
            </div>
            <div class="business-content-item-text">
              <div>{{ $t('home.business.646v04syy6g0') }}</div>
              <div class="email-box">Lucy.zhan@danghuan.com</div>
            </div>
          </div>
        </div>
      </div>
      <div class="business-right-container">
        <div class="right-form-title-box">{{ $t('home.business.646v04syya80') }}</div>
        <el-form
          class="business-right-form"
          ref="form"
          :model="form"
          :rules="rules"
          label-width="0px"
        >
          <el-form-item class="normal-form-item" label="" prop="customerName">
            <el-input
              :placeholder="$t('home.business.646v04syydg0')"
              v-model="form.customerName"
              :maxlength="32"
            >
            </el-input>
          </el-form-item>
          <el-form-item class="select-mobile-number-form-item" label="" prop="mobileNumber">
            <el-input
              ref="input-mobileNumber"
              :placeholder="$t('home.business.646v04syyh40')"
              v-model.number="form.mobileNumber"
              :maxlength="16"
              @input="handleInputMoboleNumber('mobileNumber', $event)"
            >
              <!-- <el-select
                v-model="form.mobileAreaCode"
                slot="prepend"
                :popper-append-to-body="false"
                style="width: 170px"
              >
                <el-option
                  v-for="(item, key) in mobileAreaCode"
                  :key="key"
                  :value="key"
                  :label="`${item} (${key})`"
                ></el-option>
              </el-select> -->
              <el-select
                v-model="form.mobileAreaCode"
                slot="prepend"
                :popper-append-to-body="false"
                style="width: 160px"
              >
                <img :src="getFlagUrl" alt="" slot="prefix" style="width: 24px; height: 24px" />
                <el-option
                  v-for="(item, key) in mobileAreaCode"
                  :key="item.areaCode"
                  :value="item.areaCode"
                >
                  <div style="display: flex; align-items: center">
                    <img
                      :src="item.flagUrl"
                      alt=""
                      style="width: 24px; height: 24px; margin-right: 10px"
                    />
                    {{ item.areaCode }} {{ item.countryName }}
                  </div>
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item class="normal-form-item" label="" prop="email">
            <el-input
              :placeholder="$t('home.business.646v04syyyw0')"
              v-model="form.email"
              :maxlength="50"
            >
            </el-input>
          </el-form-item>
          <el-form-item class="normal-form-item region-form-item" label="" prop="countryCode">
            <div class="region-item-name">{{ $t('home.business.646v0gsyz1s0') }}</div>
            <el-select
              v-model="form.countryCode"
              :popper-append-to-body="false"
              :placeholder="$t('home.business.646v04syz1s0')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, key) in nationNameAndNationNo"
                :key="key"
                :value="key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="normal-form-item privacy-policy-form-item" label="" prop="">
            <div class="agree-policy-container">
              <div class="agree-policy-box">
                <img
                  @click="form.checked = !form.checked"
                  :src="form.checked ? checkedIcon : uncheckedIcon"
                  class="check-icon"
                />
                {{ $t('home.business.646v04syz4o0') }}
              </div>
              <span @click="handlePolicy" class="policy-text">{{
                $t('home.business.646v04syzkc0')
              }}</span>
            </div>
          </el-form-item>
          <el-form-item label="" prop="">
            <div class="btn-container">
              <div class="btn-box" @click="handleSubmitForm">
                {{ $t('home.business.646v04syzok0') }}
                <img :src="arrowIcon" class="arrow-icon" />
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isES } from '@/locales';
import { getEnumList, businessContactUs, getMobileAreaCode } from '@/services/api/home';
import Head from '../../components/head';
import Bottom from '../../components/bottom';
export default {
  name: 'Home',
  components: {
    Head,
    Bottom
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('home.business.646v04syzvo0')));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      const emailReg = RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
      if (value === '') {
        callback(new Error(this.$t('home.business.646v04syzys0')));
      } else if (!emailReg.test(value)) {
        callback(new Error(this.$t('home.business.646v04sz01o0')));
      } else {
        callback();
      }
    };
    return {
      arrowIcon: require('../../assets/image/eu-home/icon/arrow-right.png'),
      checkedIcon: require('../../assets/image/eu-home/icon/checked.png'),
      uncheckedIcon: require('../../assets/image/eu-home/icon/unchecked.png'),
      isChecked: false,
      businessList: [
        {
          id: 1,
          title: this.$t('home.business.title1'),
          texts: [this.$t('home.business.text1-1')]
        },
        {
          id: 2,
          title: this.$t('home.business.title2'),
          texts: [this.$t('home.business.text2-1')]
        },
        {
          id: 3,
          title: this.$t('home.business.title3'),
          texts: [this.$t('home.business.text3-1'), this.$t('home.business.text3-2')]
        }
      ],
      form: {
        customerName: '',
        mobileAreaCode: '+34',
        mobileNumber: '',
        email: '',
        countryCode: '',
        checked: false
      },
      rules: {
        customerName: [
          { required: true, message: this.$t('home.business.646v04sz04g0'), trigger: 'change' }
        ],
        mobileNumber: [{ required: true, validator: validatePhone, trigger: 'change' }],
        email: [{ required: true, validator: validateEmail, trigger: 'change' }],
        countryCode: [
          { required: true, message: this.$t('home.business.646v04syz1s0'), trigger: 'change' }
        ]
      },
      nationNameAndNationNo: {},
      mobileAreaCode: [],
      isES
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      },
      isEn() {
        return true;
      }
    }),
    getFlagUrl() {
      // form.mobileAreaCode
      let url = '';
      this.mobileAreaCode.forEach(item => {
        if (item.areaCode == this.form.mobileAreaCode) {
          url = item.flagUrl;
        }
      });
      return url;
    }
  },
  created() {
    this.getEnumList();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    handleInputMoboleNumber(prop, value) {
      const text = value?.replace(/\D*/g, '');
      const input = this.$refs[`input-${prop}`].getInput();
      input.value = text;
      this.form[prop] = text;
    },
    handleClick() {
      this.$refs.head.hidLangeList();
    },
    handlePolicy() {
      this.$router.push({ name: 'cookiePriva' });
    },
    handleSubmitForm() {
      if (!this.form.checked) {
        this.$toast(this.$t('home.business.646v04sz0740'));
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form));
          params.customerName = params.customerName.trim();
          delete params.checked;
          businessContactUs(params).then(res => {
            const { code, data } = res;
            if (code === '0000') {
              this.$toast({
                getContainer: '.home-content',
                type: 'success',
                message: this.$t('home.business.646v04sz0a00'),
                icon: require('../../assets/image/eu-home/icon/successe-icon.png'),
                className: 'toast-container'
              });
              this.form.mobileAreaCode = '+34';
              this.form.checked = false;
              this.resetForm();
            }
          });
        } else {
          Toast.fail(this.$t('home.business.646v04sz0cw0'));
          return false;
        }
      });
    },
    getEnumList() {
      getMobileAreaCode().then(res => {
        this.mobileAreaCode = {};
        const { code, data } = res;
        if (code === '0000') {
          this.mobileAreaCode = data;
        }
      });
      getEnumList().then(res => {
        this.nationNameAndNationNo = {};
        const { code, data } = res;
        if (code === '0000') {
          this.nationNameAndNationNo = data.nationNameAndNationNo;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  // PC端
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: 'PingFang SC';
    .pc_business-container {
      max-width: 1400px;
      margin: auto;
      padding: 160px 0 80px;
      .business-box {
        width: 100%;
        background: #fff;
        display: grid;
        grid-column-gap: 120px;
        grid-row-gap: 96px;
        grid-template-rows: auto;
        grid-template-columns: 1fr 2fr;
        grid-auto-columns: 1fr;
        .business-left-container {
          width: 645px;
          display: flex;
          flex-direction: column;
          .business-content {
            .business-content-title {
              color: #405FFF;
              font-family: 'PingFang SC';
              font-size: 36px;
              font-style: normal;
              font-weight: 600;
              line-height: 150%;
            }
            .business-content-sub-title {
              color: #252629;
              font-family: 'PingFang SC';
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              margin-top: 16px;
            }
            .business-content-container {
              display: flex;
              flex-direction: column;
              .business-content-item {
                display: flex;
                flex-direction: column;
                flex-shrink: 0;
                .business-content-item-title {
                  margin: 32px 0 16px;
                  color: #252629;
                  font-family: 'PingFang SC';
                  font-size: 28px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 150%;
                }
              }
              .business-content-item-text {
                color: #252629;
                font-family: 'PingFang SC';
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                &.email-row {
                  margin-top: 32px;
                }
                .email-box {
                  color: #165dff;
                  font-family: 'PingFang SC';
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 150%;
                  text-decoration-line: underline;
                  text-decoration-style: solid;
                  text-decoration-skip-ink: auto;
                  text-decoration-thickness: auto;
                  text-underline-offset: auto;
                  text-underline-position: from-font;
                  cursor: pointer;
                }
              }
            }
          }
        }
        .business-right-container {
          border-radius: 24px;
          background: #f7f8f9;
          max-width: 560px;
          padding: 42px 20px 110px 42px;

          .right-form-title-box {
            color: #252629;
            font-family: 'PingFang SC';
            font-size: 36px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            margin-bottom: 24px;
          }

          .business-right-form {
            /deep/.el-form-item {
              margin-bottom: 24px;
              &.region-form-item,
              &.privacy-policy-form-item {
                margin-bottom: 14px;
              }
              &.is-error {
                margin-bottom: 40px;
              }
            }
            /deep/.el-select-dropdown {
              box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08);
            }
            /deep/.normal-form-item {
              .el-input__inner {
                height: 56px;
                border-radius: 12px;
                color: #252629;
                &:focus {
                  border: 1px solid #252629;
                }
              }
            }
            /deep/.select-mobile-number-form-item {
              .el-input-group--prepend {
                .el-input__inner {
                  height: 56px;
                  border-radius: 0 12px 12px 0;
                  color: #252629;
                  &:focus {
                    border-radius: 0 12px 12px 0;
                    border: 1px solid #252629;
                  }
                }
                .el-input-group__prepend {
                  border: 0;
                  background: none;
                  .el-input__inner {
                    height: 56px;
                    background: #fff;
                    border-radius: 12px 0 0 12px;
                    border: 1px solid #dcdfe6;
                    border-right: 0;
                    color: #252629;
                    text-align: center;
                    &:focus {
                      height: 56px;
                      border: 1px solid #252629;
                      border-radius: 12px 0 0 12px;
                    }
                  }
                  .el-select-dropdown {
                    width: 560px;
                    left: 0px !important;
                    border-radius: 8px;
                  }
                }
              }
              &.el-form-item.is-error .el-input-group--prepend .el-input__inner {
                border-color: #f56c6c;
              }
            }
            .region-item-name {
              color: #252629;
              font-family: 'PingFang SC';
              font-size: 24px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              margin-bottom: 10px;
            }
            .agree-policy-container {
              display: flex;
              .agree-policy-box {
                display: flex;
                align-items: center;
                gap: 10px;
                color: #8f949d;
                font-family: 'PingFang SC';
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                margin-right: 6px;
                .check-icon {
                  flex-shrink: 0;
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                }
              }
              .policy-text {
                color: #405FFF;
                font-family: 'PingFang SC';
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                cursor: pointer;
              }
            }
            .btn-container {
              width: 100%;
              display: flex;
              position: relative;
              .btn-box {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                padding: 15px 24px;
                border-radius: 71px;
                background: #405FFF;

                color: #fff;
                font-family: 'PingFang SC';
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 30px */
                cursor: pointer;

                position: absolute;
                right: 0;

                .arrow-icon {
                  width: 24px;
                  height: 24px;
                  flex-shrink: 0;
                }
              }
            }
          }
          /deep/.el-input__prefix {
            display: flex;
            align-items: center;
          }
          /deep/.el-input--prefix {
            /deep/.el-input__inner {
              text-align: center;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 980px) {
  // 移动端
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: 'PingFang SC';
    .business-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 180px 30px 80px;
      width: calc(100% - 60px);
      background: #fff;
      .business-left-container {
        display: flex;
        flex-direction: column;
        .business-content {
          .business-content-title {
            color: #252629;
            font-family: 'PingFang SC';
            font-size: 48px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
          }
          .business-content-sub-title {
            color: #8f949d;
            font-family: 'PingFang SC';
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            margin: 48px 0 64px;
          }
          .business-content-container {
            display: flex;
            flex-direction: column;
            gap: 64px;
            .business-content-item {
              display: flex;
              flex-direction: column;
              flex-shrink: 0;
              .business-content-item-title {
                color: #252629;
                font-family: 'PingFang SC';
                font-size: 32px;
                font-style: normal;
                font-weight: 500;
                line-height: 150%;
                margin-bottom: 24px;
              }
            }
            .business-content-item-text {
              color: #8f949d;
              font-family: 'PingFang SC';
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              .email-box {
                color: #165dff;
                font-family: 'PingFang SC';
                font-size: 28px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                text-decoration-line: underline;
                text-decoration-style: solid;
                text-decoration-skip-ink: auto;
                text-decoration-thickness: auto;
                text-underline-offset: auto;
                text-underline-position: from-font;
                cursor: pointer;
              }
            }
          }
        }
      }
      /deep/.el-input__prefix {
        display: flex;
        align-items: center;
      }
      /deep/.el-input--prefix {
        /deep/.el-input__inner {
          text-align: center;
        }
      }
      .business-right-container {
        border-radius: 24px;
        background: #f7f8f9;
        width: calc(100% - 48px);
        padding: 64px 24px 100px;
        margin-top: 48px;

        .right-form-title-box {
          color: #252629;
          font-family: 'PingFang SC';
          font-size: 36px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          margin-bottom: 48px;
        }

        .business-right-form {
          /deep/.el-form-item {
            margin-bottom: 12px;
            &.region-form-item,
            &.privacy-policy-form-item {
              margin-bottom: 4px;
            }
            &.is-error {
              margin-bottom: 24px;
            }
          }
          /deep/.el-select-dropdown {
            box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08);
          }
          /deep/.normal-form-item {
            .el-input__inner {
              height: 48px;
              border-radius: 12px;
              color: #252629;
              &:focus {
                border: 1px solid #252629;
              }
            }
          }
          /deep/.select-mobile-number-form-item {
            .el-input-group--prepend {
              .el-input__inner {
                height: 48px;
                border-radius: 0 12px 12px 0;
                color: #252629;
                &:focus {
                  border-radius: 0 12px 12px 0;
                  border: 1px solid #252629;
                }
              }
              .el-input-group__prepend {
                border: 0;
                background: none;
                .el-input__inner {
                  height: 48px;
                  background: #fff;
                  border-radius: 12px 0 0 12px;
                  border: 1px solid #dcdfe6;
                  border-right: 0;
                  color: #252629;
                  text-align: center;
                  &:focus {
                    height: 48px;
                    border: 1px solid #252629;
                    border-radius: 12px 0 0 12px;
                  }
                }
                .el-select-dropdown {
                  width: calc(100vw - 1.44rem);
                  left: 0px !important;
                  border-radius: 8px;
                }
              }
            }
            &.el-form-item.is-error .el-input-group--prepend .el-input__inner {
              border-color: #f56c6c;
            }
          }
          .region-item-name {
            color: #252629;
            font-family: 'PingFang SC';
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            padding: 24px;
            margin-bottom: 24px;
          }
          .agree-policy-container {
            display: flex;
            align-items: center;
            .agree-policy-box {
              display: flex;
              align-items: center;
              gap: 10px;
              color: #8f949d;
              font-family: 'PingFang SC';
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              margin-right: 6px;
              .check-icon {
                flex-shrink: 0;
                width: 32px;
                height: 32px;
                cursor: pointer;
              }
            }
            .policy-text {
              color: #405FFF;
              font-family: 'PingFang SC';
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              cursor: pointer;
            }
          }
          .btn-container {
            width: 100%;
            display: flex;
            position: relative;
            .btn-box {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 10px;
              padding: 20px 40px;
              border-radius: 126px;
              background: #405FFF;

              color: #fff;
              font-family: 'PingFang SC';
              font-size: 28px;
              font-style: normal;
              font-weight: 500;
              line-height: 150%; /* 30px */
              cursor: pointer;

              position: absolute;
              right: 0;

              .arrow-icon {
                width: 32px;
                height: 32px;
                flex-shrink: 0;
              }
            }
          }
        }
      }
    }
  }
}
/deep/.el-select-dropdown__item {
  &:hover,
  &.selected {
    background: #405FFF;
    color: #fff;
    font-weight: 700;
  }
}
/deep/.van-toast.toast-container {
  padding: 16px 12px;
  min-height: 50px;
  width: 100px;
  word-break: break-word;
  .van-toast__icon {
    font-size: 32px !important;
    img {
      width: 32px !important;
    }
  }
}
</style>
